import { Component, inject } from '@angular/core'
import {
	NavigationEnd,
	Router,
	RouterLink,
	RouterOutlet,
} from '@angular/router'
import { NgStyle } from '@angular/common'
import { PermissionsService } from '@client/Services/PermissionsService'

@Component({
	selector: 'my-app',
	templateUrl: './App.Component.html',
	imports: [RouterLink, RouterOutlet, NgStyle],
})
export class AppComponent {
	protected url: string = ''

	protected readonly permissionsService: PermissionsService

	constructor() {
		const router: Router = inject(Router)
		this.permissionsService = inject(PermissionsService)

		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.url = event.url
			}
		})
	}

	public logout = async (): Promise<void> => {
		await this.permissionsService.logout()

		window.location.href = '/'
	}
}
